import React, { useContext, useState } from 'react';
import { RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import styles from './FONASUAccountFinderLandingScreen.css';

const FONASUAccountFinderLandingScreen = () => {
  const { next, formProps } = useContext(FlowContext);
  const [accountTypeOption, setAccountTypeOption] = useState('');

  // sets the account type option
  const handleAccountOption = ({ target: { value } }) => {
    return setAccountTypeOption(value);
  };

  return (
    <>
      <div className="container">
        <div className="title-wrapper">
          <h1 className="account-finder-heading">Open a New Account</h1>
          <h2 className="account-finder-subheading">
            Select either a mutual fund or brokerage account.
          </h2>
        </div>
        <div className="account-option-input">
          <RadioGroupField
            name="accountTypeOption"
            title="What type of account would the client like to open?"
            options={[
              {
                title: 'Mutual fund account',
                value: 'mfAccountType'
              },
              {
                title: 'Brokerage account',
                value: 'brkAccountType'
              }
            ]}
            {...formProps.accountTypeOption}
            onChange={handleAccountOption}
          />
        </div>
      </div>

      <div className="btn-container">
        <MFBeaconButton
          noButtonMargin
          variant="primary"
          size="normal"
          data-name="accountFinderContinueBtn"
          onClick={() => next(accountTypeOption)()}
          label="Continue"
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FONASUAccountFinderLandingScreen;
